import { create } from 'zustand';
import { RootLoader, RootLoaders } from 'src/types';

interface RootLoadersState {
  rootLoaders: RootLoaders;
  getRootLoader: (loaderId: string) => RootLoader;
  setRootLoader: (loaderId: string, rootLoader: RootLoader) => void;
  incrementPending: (loaderId: string) => void;
  decrementPending: (loaderId: string) => void;
  someRootPending: () => boolean;
}

export const useRootLoadersStore = create<RootLoadersState>((set, get) => ({
  rootLoaders: {},

  getRootLoader: (loaderId: string) => {
    return get().rootLoaders[loaderId] || { pendingCounter: 0 };
  },

  setRootLoader: (loaderId: string, rootLoader: RootLoader) => {
    set((state) => ({
      rootLoaders: {
        ...state.rootLoaders,
        [loaderId]: rootLoader,
      },
    }));
  },

  incrementPending: (loaderId: string) => {
    set((state) => {
      const currentLoader = state.rootLoaders[loaderId] || { pendingCounter: 0 };
      return {
        rootLoaders: {
          ...state.rootLoaders,
          [loaderId]: {
            pendingCounter: currentLoader.pendingCounter + 1,
          },
        },
      };
    });
  },

  decrementPending: (loaderId: string) => {
    set((state) => {
      const currentLoader = state.rootLoaders[loaderId] || { pendingCounter: 0 };
      return {
        rootLoaders: {
          ...state.rootLoaders,
          [loaderId]: {
            pendingCounter: Math.max(0, currentLoader.pendingCounter - 1),
          },
        },
      };
    });
  },

  someRootPending: () => {
    const { rootLoaders } = get();
    return Object.values(rootLoaders).some(
      (rootLoader) => (rootLoader?.pendingCounter || 0) > 0
    );
  },
}));